<template>
  <div class="e4s-flex-column e4s-gap--standard">
    <div class="e4s-flex-row e4s-justify-flex-space-between">
      <div class="e4s-flex-row e4s-gap--standard e4s-header--500">
        <div v-text="message.title"></div>
      </div>

      <div v-text="getAttemptNumber"></div>
    </div>

    <div
      class="e4s-flex-row e4s-justify-flex-space-between e4s-subheader--general-x e4s-subheader--300-x"
    >
      <div class="e4s-flex-row e4s-gap--standard">
        <div class="nextup-label">Next Up:</div>
        <div v-text="payload.athlete.name" class="nextup-athlete"></div>
      </div>

      <div v-text="getTrialNumber"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { SocketResultMessagePayloadFieldNextup } from '@/components/results/socket/models/field-nextup'
import type { LiveFeedSocketMessage } from '@/components/results/socket/live-feed/models/live-feed-models'
/*
{
	"guid": "s-5a08fe79-1207-4ea8-b4d6-d2e236d6d929",
	"time": "2025-06-13T05:51:52.359Z",
	"displayTime": "06:51:52",
	"type": "FIELD_RESULT",
	"action": "field-nextup",
	"payload": {
		"athlete": {
			"id": 192662,
			"name": "Jacob FOORD"
		},
		"comp": {
			"id": 617,
			"name": "English Schools 2024"
		},
		"event": {
			"id": 13817,
			"name": "Discus SB",
			"heatNo": 5
		}
	},
	"title": "F35: Discus SB"
}
 */

const props = defineProps({
  message: {
    type: Object as PropType<LiveFeedSocketMessage>,
    required: true
  }
})

const payload = computed<SocketResultMessagePayloadFieldNextup>(() => {
  return props.message.payload as SocketResultMessagePayloadFieldNextup
})

const getTrialNumber = computed(() => {
  return payload.value.event.heatNo ? 'Trial: ' + payload.value.event.heatNo : ''
})

const getAttemptNumber = computed(() => {
  return payload.value.athlete.attempt ? 'Attempt: ' + payload.value.athlete.attempt : ''
})
</script>

<style>
.nextup-label {
  font-weight: bold;
}
.nextup-athlete {
  color: var(--e4s-color-primary);
}
</style>
